import React from "react";

import { CategoryDetails } from "./category-details";

export const CategoryDetailsContainer = ({ category, products }) => {
  return <CategoryDetails category={category} products={products} />;
};
